export const ORCHESTRATOR_ENDPOINTS = {
  CONVERSATIONS: {
    BASE: "/api/v1/conversations/",
    BY_ID: (conversationId: string) => `/api/v1/conversations/${conversationId}`,
    BY_SHORT_CODE: (shortCode: string) => `/api/v1/conversations/short/${shortCode}`,
    SUMMARY: {
      BY_ID: (conversationId: string) => `/api/v1/conversations/summary/${conversationId}`,
    },
    SHARE_STATE: (conversationId: string) =>
      `/api/v1/conversations/${conversationId}/share-state`,
    SHARE_LOOKUP: (conversationId: string) =>
      `/api/v1/conversations/${conversationId}/share/lookup`,
    SHARE_MODE: (conversationId: string) =>
      `/api/v1/conversations/${conversationId}/share-mode`,
    SHARES: (conversationId: string) =>
      `/api/v1/conversations/${conversationId}/shares`,
    SHARE_BY_ID: (conversationId: string, shareId: string) =>
      `/api/v1/conversations/${conversationId}/shares/${shareId}`,
    SHARED_WITH_ME: "/api/v1/conversations/shared-with-me",
  },
  MESSAGES: {
    BASE: "/api/v1/messages/",
  },
  MODEL_RUNS: {
    BASE: "/api/v1/model-runs/",
    TIME_SERIES: (runId: string) => `/api/v1/model-runs/${runId}/time-series`,
    FORECASTS: (runId: string) => `/api/v1/model-runs/${runId}/forecasts`,
    COPILOT_RESPONSE: (runId: string) => `/api/v1/model-runs/copilot/run/${runId}`,
    PATIENT_THRESHOLDS: (patientId: string) => `/api/v1/model-runs/patient/${patientId}/thresholds`,
  },
  PATIENT: {
    BY_SUBJECT_ID: (subjectId: string) => `/api/v1/patient/data/metadata/${subjectId}`,
  },
  MEMORY: {
    FACTS: (patientId: string) => `/api/v1/memory/${patientId}/facts`,
    STATUS: (patientId: string) => `/api/v1/memory/${patientId}/status`,
    FACT_BY_ID: (patientId: string, factUuid: string) =>
      `/api/v1/memory/${patientId}/facts/${factUuid}`,
    FACT_INVALIDATE: (patientId: string, factUuid: string) =>
      `/api/v1/memory/${patientId}/facts/${factUuid}/invalidate`,
    FACT_RESTORE: (patientId: string, factUuid: string) =>
      `/api/v1/memory/${patientId}/facts/${factUuid}/restore`,
  },
};

export const ADMIN_ENDPOINTS = {
  GUIDELINES: {
    CHUNKS: "/admin/guidelines/chunks",
    CHUNK_BY_ID: (chunkId: string) => `/admin/guidelines/chunks/${chunkId}`,
    DOCS: "/admin/guidelines/docs",
    DOC_BY_ID: (docId: string) => `/admin/guidelines/docs/${docId}`,
    DISPLAY: "/api/v1/guidelines/docs/display",
  }
}

export const OPENEMR_ENDPOINTS = {
  OPENEMR_PATIENTS: "/api/v1/openemr/patients"
};
